import React from 'react';
import { compose } from 'ramda';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import styleFile from '../style';
import LoyaltyPublic from './Public';
import LoyaltyInfo from './Info';
import {connect} from 'react-redux';

const FidelTourManagement = ({theme,  theme: { styles: { classes }}, loyaltyUser, customerForm, content }) => {

  const getLoyaltyLogoText = (key) => {
    const translated = content ? content.t(`_%${key}%_`) : '';
    return translated.trim() !== '' && translated !== key ? translated : null;
  };

  const loyaltyImageBanner= getLoyaltyLogoText('loyalty_image_banner');

  return (
    <>
      {loyaltyUser && <div className={[theme.computedInnerStyle, customerForm ? classes.marginCustomerForm : ''].join(' ') }>
        <div className={classes.content}>
          <LoyaltyInfo infoUser={ loyaltyUser } customerForm={customerForm} />
        </div>
      </div>
      }
      {!loyaltyUser &&        
        <div className={[classes.content, customerForm ? classes.contentCustomerForm : ''].join(' ')}
           style={loyaltyImageBanner ? { backgroundImage: `url(${loyaltyImageBanner})`, backgroundSize: 'cover' } : undefined}
        >
          <LoyaltyPublic customerForm={customerForm}/>
        </div>
      }
    </>
  );

};

const mapStateToProps = (store) => {  
  return {
    loyaltyUser : store.getIn(['customer', 'loyalty', 'user','user_id'], null) && store.getIn(['customer', 'loyalty','user'], null)
  };
};

export default compose(connect(mapStateToProps), withThemeJSS({ styleFile, link: true, displayName: 'FidelTourManagement' }), withContent('i18n'))(FidelTourManagement);